import { AxiosInterceptor } from "api/core/consts";

export const calendarApi = {
  getCalendar: (calenderId) => AxiosInterceptor.get('/calender/' + calenderId),
  searchCalendar: (body) => AxiosInterceptor.post('/calender/search?size=100', body),
  createCalendar: (body) => AxiosInterceptor.post('/calender', body),
  updateCalendar: (calenderId, body) => AxiosInterceptor.put('/calender/' + calenderId, body),
  deleteCalendar: (calenderId) => AxiosInterceptor.delete('/calender/' + calenderId),
};
